export enum GameType {
  Unknown,
  Praia,
  Rex,
}
